export default {
    sourceType: 'module',
    plugins: [
        'objectRestSpread',
        'jsx',
        'typescript',
        'classProperties',
        'asyncGenerators',
        'dynamicImport',
        'exportDefaultFrom',
        'exportNamespaceFrom',
        'optionalChaining',
        'nullishCoalescingOperator'
    ]
};
